// extracted by mini-css-extract-plugin
export default {"container":"acceptance-checks_container__nAPTn","checkbox":"acceptance-checks_checkbox__LMuhl","legal-document-content":"acceptance-checks_legal-document-content__xKQrU"};